import gql from "graphql-tag";

export const userTeamsRolesQuery = gql`
  query userTeamsRoles($id: ID!) {
    user(id: $id) {
      id
      userTeams {
        id
        leaveAdminIds
        sickNoteAdminIds
        timeRegistrationApproverIds
      }
    }
  }
`;
